import React from 'react';

import UserProfile from 'common/components/Profile';

const Profile = () => <UserProfile />;

export default Profile;
